import { t } from "@/i18n-js/instance";
import { PageMetaData } from "@/react/components/Layout/PageMetaData";
import { StandardLayout } from "@/react/components/Layout/StandardLayout";
import { StandardLayoutHeaderWithPortal } from "@/react/components/Layout/StandardLayoutV2/StandardLayoutHeader/StandardLayoutHeaderWithPortal";
import { useActiveView } from "@/react/hooks/utils/useActiveView";
import { usePunditUserContext } from "@circle-react/contexts";
import { useCommunitySettingShow } from "@circle-react/hooks/UseCommunitySetting";
import type { ViewSwitcherLayoutTypes } from "@circle-react-shared/ViewSwitcher";
import { useNavigationLinks } from "@circle-react-uikit/HeaderV3/NavigationBar/hooks/useNavigationLinks";
import { Typography } from "@circle-react-uikit/Typography";
import { CalendarView } from "./CalendarView";
import { EventsList } from "./EventsList";
import { RightOptions } from "./RightOptions";
import { EVENT_LAYOUT_TYPES } from "./constants";

export const AllEventsPage = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  const { data } = useCommunitySettingShow();
  const { eventLink } = useNavigationLinks();

  const communitySetting = data?.community_settings || currentCommunitySettings;
  const defaultActiveView = communitySetting?.public_events_view;
  const isPublicEventsPage = Boolean(communitySetting?.public_events_page);

  const [activeView, setActiveView] = useActiveView({
    defaultCommunityView: defaultActiveView as ViewSwitcherLayoutTypes,
    views: EVENT_LAYOUT_TYPES,
    activeStorageKey: "all_events_active_view",
  });

  const isCalendarView = activeView === EVENT_LAYOUT_TYPES.CALENDAR;
  const eventPageTitle = eventLink?.label || t("all_events.title");

  if (!communitySetting) {
    return null;
  }

  return (
    <>
      <StandardLayout.Breadcrumb />
      <StandardLayoutHeaderWithPortal
        leftContent={
          <Typography.TitleSm as="h1" weight="semibold">
            {eventPageTitle}
          </Typography.TitleSm>
        }
        rightContent={
          <RightOptions
            activeView={activeView}
            communityData={data}
            isPublicEventsPage={isPublicEventsPage}
            setActiveView={setActiveView}
          />
        }
      />
      <StandardLayout.Body
        hasPaddingTopMobile={false}
        wrapperClassName="!mx-0 !pt-6"
      >
        <PageMetaData title={eventPageTitle} />
        {isCalendarView ? (
          <StandardLayout.Content className="!mx-6 !max-w-full">
            <CalendarView />
          </StandardLayout.Content>
        ) : (
          <StandardLayout.Content>
            <EventsList activeView={activeView} />
          </StandardLayout.Content>
        )}
      </StandardLayout.Body>
    </>
  );
};

export default AllEventsPage;
